<template>
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column">
      <div class="flex-grow-1 pb-5">
        <!--begin::Info-->
        <h1 style="text-transform: uppercase">{{ pageTitle }}</h1>
        <div class="d-flex align-items-center mb-6">
          <span class="text-muted font-weight-bold font-size-lg flex-grow-1"
            >Erstellen Sie ein hier ein Dokument.</span
          >
          <div class="symbol symbol-50">
            <span class="symbol-label bg-light-light">
              <img
                src="/media/svg/icons/Files/File.svg"
                class="h-50 align-self-center"
                alt=""
              />
            </span>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :is-full-page="true"
          ></loading>
        </div>

        <v-app>
          <v-container>
            <v-row>
              <v-col md="12" class="pt-9 pb-12">
                <div v-if="newInvoice.status !== status_types.STATUS_DRAFT">
                  <v-btn
                    class="primary float-right ma-2 custom_button"
                    type="submit"
                    large
                    @click="sendEmail()"
                  >
                    Sende E-Mail
                    <v-icon dark right>
                      mdi-send-circle
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="primary float-right ma-2 custom_button"
                    type="submit"
                    large
                    width="125"
                    @click="getPdf()"
                  >
                    Download
                    <v-icon dark right>
                      mdi-file-pdf
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="primary float-right ma-2 mr-15 primary"
                    v-if="this.newInvoice.documents_type_id !== 3"
                    type="submit"
                    large
                    width="160"
                    @click="editDocument()"
                  >
                    Editieren
                    <v-icon right>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
                <div v-if="newInvoice.status === status_types.STATUS_DRAFT">
                  <v-btn
                    class="primary float-right ma-2 ml-10"
                    type="submit"
                    large
                    width="125"
                    @click="saveInvoice(status_types.STATUS_SAVED)"
                  >
                    Bestätigen
                    <v-icon dark right>
                      mdi-file
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="primary float-right ma-2 custom_button"
                    type="submit"
                    large
                    width="125"
                    @click="saveInvoice(status_types.STATUS_DRAFT)"
                  >
                    Speichern
                    <v-icon dark right>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="primary float-right ma-2 custom_button"
                    :disabled="!newInvoice.unique_hash || !newInvoice.user_id"
                    type="submit"
                    large
                    width="125"
                    @click="getPDFDraft()"
                  >
                    Vorschau<br />(PDF)
                    <v-icon dark right>
                      mdi-file-pdf
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="10" class="ma-4">
                <v-alert dense outlined type="info">
                  Um die E-Rechnung zu prüfen, laden Sie bitte die
                  <strong>Vorschau-PDF oder fertige Rechnung</strong> herunter
                  und öffnen Sie diese anschließend über das ELSTER-Prüfportal
                  unter
                  <br />
                  <br />
                  <a
                    href="https://www.elster.de/eportal/e-rechnung"
                    target="_blank"
                    rel="noopener"
                  >
                    www.elster.de/eportal/e-rechnung </a
                  >.
                </v-alert>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="ma-4">
                <strong>Absender:</strong> {{ company.Name }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pb-9">
                <CustomerSelect
                  :selectedCustomer="this.customerSelect"
                  :status="newInvoice.status"
                  @update="customerSelected"
                >
                </CustomerSelect>
              </v-col>
              <v-col cols="6" class="pb-9">
                <v-row>
                  <!-- Linke Spalte: Rechnungsnummer -->
                  <v-col cols="6">
                    <v-text-field
                      v-model="newInvoice.invoice_number"
                      label="Rechnungsnummer"
                      hide-details="auto"
                      width="15"
                      :prefix="getInvoicePrefix()"
                      :disabled="true"
                    ></v-text-field>
                  </v-col>

                  <!-- Rechte Spalte: Datum, Leistungszeitraum, Zahlungsstatus -->
                  <v-col cols="6">
                    <!-- Datum -->
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="newInvoice.invoice_date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      bottom
                      attach
                      :disabled="
                        newInvoice.status === 'SAVED' ||
                          newInvoice.status === 'SEND'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newInvoice.invoice_date"
                          label="Datum *"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :disabled="
                            newInvoice.status !== status_types.STATUS_DRAFT
                          "
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newInvoice.invoice_date"
                        no-title
                        scrollable
                        :first-day-of-week="1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Abbrechen
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(newInvoice.invoice_date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>

                    <!-- Leistungszeitraum (ein Picker, range-modus) unter dem Datum -->
                    <v-menu
                      ref="menuServiceRange"
                      v-model="menuServiceRange"
                      :close-on-content-click="false"
                      :return-value.sync="newInvoice.service_range"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      bottom
                      attach
                      :disabled="
                        newInvoice.status === 'SAVED' ||
                          newInvoice.status === 'SEND'
                      "
                      class="mt-2"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="serviceRangeLabel"
                          label="Leistungszeitraum *"
                          prepend-icon="mdi-calendar-range"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :disabled="
                            newInvoice.status !== status_types.STATUS_DRAFT
                          "
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        v-model="newInvoice.service_range"
                        range
                        no-title
                        scrollable
                        :first-day-of-week="1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menuServiceRange = false"
                        >
                          Abbrechen
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.menuServiceRange.save(
                              newInvoice.service_range
                            )
                          "
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>

                    <!-- Zahlungsstatus unter dem Leistungszeitraum -->
                    <div class="mt-3">
                      <span style="color: rgba(0, 0, 0, 0.6);"
                        >Zahlungsstatus</span
                      >
                      <v-switch
                        style="margin-top: 7px;"
                        v-model="newInvoice.is_paid"
                        :label="
                          newInvoice.is_paid
                            ? 'Zahlung eingegangen'
                            : 'Zahlung offen'
                        "
                        hide-details="auto"
                        width="15"
                        :disabled="
                          newInvoice.status === status_types.STATUS_DRAFT ||
                            newInvoice.documents_type_id === 3
                        "
                        @change="updatePaidStatus"
                      ></v-switch>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-container
            class="box-border bg-white border border-gray-200 border-solid rounded-b mb-6"
          >
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="newInvoice.notes"
                  append-icon="mdi-note"
                  name="input-7-1"
                  label="Kopftext (optional)"
                  row-height="10px"
                  dense
                  auto-grow
                  filled
                  hide-details
                  background-color="#f7f7f7"
                  style="padding: 15px"
                  :disabled="newInvoice.status !== status_types.STATUS_DRAFT"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-row>
              <v-col cols="12">
                <!-- Items -->
                <table
                  class="w-full text-center item-table"
                  style="width: 100%"
                >
                  <colgroup>
                    <col style="width: 35%" />
                    <col style="width: 12.5%" />
                    <col style="width: 10%" />
                    <col style="width: 12.5%" />
                    <!--                      <col v-if="discountPerItem === 'YES'" style="width: 15%" />-->
                    <col style="width: 15%" />
                  </colgroup>
                  <thead class="bg-white border border-gray-200 border-solid">
                    <tr>
                      <th
                        class="px-5 py-3 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                      >
                        <span>
                          Artikel
                        </span>
                      </th>
                      <th
                        class="px-5 py-3 text-sm not-italic font-medium leading-5 text-right text-gray-700 border-t border-b border-gray-200 border-solid"
                      >
                        Anzahl
                      </th>
                      <th
                        class="px-1 py-1 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                      ></th>
                      <th
                        class="px-5 py-3 text-sm not-italic font-medium leading-5 text-left text-gray-700 border-t border-b border-gray-200 border-solid"
                      >
                        Stückpreis
                      </th>
                      <th
                        class="px-5 py-3 text-sm not-italic font-medium leading-5 text-right text-gray-700 border-t border-b border-gray-200 border-solid"
                      >
                        <span>
                          Summe
                        </span>
                      </th>
                    </tr>
                  </thead>

                  <invoice-item
                    v-for="(item, index) in newInvoice.items"
                    :key="item.id"
                    :index="index"
                    :item-data="item"
                    :invoice-items="newInvoice.items"
                    :currency="currency"
                    :customerSelect="newInvoice.client_id"
                    :status="newInvoice.status"
                    :unit_item="unit_item"
                    @remove="removeItem"
                    @update="updateItem"
                  />
                </table>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                class="flex justify-center w-full px-6 py-3 text-base border-b border-gray-200 border-solid cursor-pointer text-primary-400 hover:bg-gray-200"
              >
                <div
                  class="d-flex justify-center mb-6"
                  @click="addItem"
                  v-if="newInvoice.status === status_types.STATUS_DRAFT"
                >
                  <div class="ma-2">
                    <v-icon color="primary" left> mdi-plus-circle</v-icon>
                    Position hinzufügen
                  </div>
                </div>
                <v-divider horizontal></v-divider>
              </v-col>
            </v-row>
          </v-container>

          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="newInvoice.additional_notes"
                  prepend-icon="mdi-note"
                  name="input-7-1"
                  label="Fußtext (optional)"
                  row-height="10px"
                  dense
                  auto-grow
                  filled
                  background-color="#f7f7f7"
                  style="padding: 15px"
                  :disabled="newInvoice.status !== status_types.STATUS_DRAFT"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="ml-4">
                <v-select
                  prepend-icon="mdi-bank-plus"
                  filled
                  background-color="#f7f7f7"
                  style="font-size: 12px;"
                  v-model="newInvoice.fixed_texts_id"
                  :items="this.selectedFixedTexts"
                  name="textblock"
                  item-value="id"
                  item-text="short"
                  label="Auswahl der Zahlungsmodalität"
                  width="15"
                  dense
                  attach=""
                  :disabled="newInvoice.status !== status_types.STATUS_DRAFT"
                >
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{
                      data.item.short +
                        " - " +
                        (data.item.description.length > 45
                          ? data.item.description.slice(0, 45) + "..."
                          : data.item.description)
                    }}
                  </template>
                </v-select>
                <v-text-field
                  prepend-icon="mdi-bank"
                  :value="this.bankDetails[0] ? getBankInformations() : ''"
                  label="Bankdetails"
                  item-value="id"
                  filled
                  background-color="#f7f7f7"
                  style="font-size: 12px;"
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <!--              <v-col cols="6">
                              <v-file-input
                                v-model="newInvoice.files"
                                type="file"
                                chips
                                counter
                                multiple
                                filled
                                background-color="#f7f7f7"
                                label="Pdf upload (optional)"
                                truncate-length="28"
                                style="padding: 15px"
                                accept=".pdf"
                                :disabled="newInvoice.status !== status_types.STATUS_DRAFT"
                              ></v-file-input>
                            </v-col>-->
              <v-col
                cols="12"
                sm="6"
                md="4"
                offset-sm="6"
                offset-md="8"
                class="d-flex flex-column float-right invoice-summary-col"
              >
                <v-simple-table dense style="width: 100%" class="summary-table">
                  <template v-slot:default>
                    <tbody>
                      <tr class="summary-row summary-row--muted">
                        <td class="summary-label-cell">
                          <span class="summary-label">Gesamtsumme Netto</span>
                        </td>
                        <td class="summary-value-cell">
                          <div class="summary-value">
                            <span
                              v-html="formatMoney(newInvoice.sub_total, 0, 2)"
                            ></span>
                            <span class="summary-currency">€</span>
                          </div>
                        </td>
                      </tr>
                      <tr class="summary-row summary-row--action">
                        <td class="summary-label-cell">
                          <span class="summary-label">Rabattabzug</span>
                        </td>
                        <td class="summary-action-cell">
                          <v-text-field
                            v-if="isDiscountInputVisible || hasDiscountValue"
                            ref="discountPercentField"
                            :value="discountPercentInput"
                            suffix="%"
                            filled
                            dense
                            hide-details
                            background-color="#f7f7f7"
                            class="summary-discount-field"
                            inputmode="decimal"
                            :disabled="
                              newInvoice.status !== status_types.STATUS_DRAFT
                            "
                            @input="updateDiscountPercent"
                            @blur="normalizeDiscountPercentInput"
                          ></v-text-field>
                          <button
                            v-else
                            type="button"
                            class="summary-discount-trigger"
                            :disabled="
                              newInvoice.status !== status_types.STATUS_DRAFT
                            "
                            @click="openDiscountInput"
                          >
                            <v-icon small>mdi-plus</v-icon>
                            <span>Gesamtrabatt hinzufügen</span>
                          </button>
                        </td>
                      </tr>
                      <tr
                        v-if="hasDiscountValue"
                        class="summary-row summary-row--discount"
                      >
                        <td class="summary-label-cell">
                          <span class="summary-label">
                            Rabattabzug
                            <span class="summary-inline-meta">
                              {{
                                formatDiscountPercent(
                                  newInvoice.discount_percent
                                )
                              }}
                              %
                            </span>
                          </span>
                        </td>
                        <td class="summary-value-cell">
                          <div class="summary-value summary-value--discount">
                            <span class="summary-prefix">-</span>
                            <span
                              v-html="
                                formatMoney(newInvoice.discount_amount, 0, 2)
                              "
                            ></span>
                            <span class="summary-currency">€</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        v-if="hasDiscountValue"
                        class="summary-row summary-row--muted"
                      >
                        <td class="summary-label-cell">
                          <span class="summary-label">Netto nach Rabatt</span>
                        </td>
                        <td class="summary-value-cell">
                          <div class="summary-value">
                            <span
                              v-html="formatMoney(discountedSubTotal, 0, 2)"
                            ></span>
                            <span class="summary-currency">€</span>
                          </div>
                        </td>
                      </tr>
                      <tr class="summary-row summary-row--tax-treatment">
                        <td colspan="2" class="summary-tax-treatment-cell">
                          <v-select
                            v-model="newInvoice.tax_type_id"
                            :items="taxes"
                            item-text="name"
                            item-value="id"
                            label="Umsatzsteuerliche Behandlung"
                            filled
                            dense
                            hide-details
                            background-color="#f7f7f7"
                            class="summary-tax-select"
                            :disabled="
                              newInvoice.status !== status_types.STATUS_DRAFT
                            "
                            @change="onTaxTypeChanged"
                          ></v-select>
                        </td>
                      </tr>
                      <tr
                        v-if="isIntraCommunityTax"
                        class="summary-row summary-row--tax-hint"
                      >
                        <td colspan="2">
                          Innergemeinschaftliche Lieferung: USt-IdNr. und
                          EU-Lieferland prüfen.
                        </td>
                      </tr>
                      <tr class="summary-row summary-row--muted">
                        <td class="summary-label-cell">
                          <span class="summary-label">
                            Umsatzsteuer {{ taxPercentLabel }}%
                          </span>
                        </td>
                        <td class="summary-value-cell">
                          <div class="summary-value">
                            <span
                              v-html="formatMoney(newInvoice.tax, 0, 2)"
                            ></span>
                            <span class="summary-currency">€</span>
                          </div>
                        </td>
                      </tr>
                      <!--                      <Tax
                                            :taxes="taxes"
                                            :total="newInvoice.sub_total"
                                            :taxTypeFromInvoice="newInvoice.taxtype"
                                            :status_types="newInvoice.status"
                                            @remove="removeInvoiceTax"
                                            @update="updateTax"
                                          ></Tax>-->
                      <!--                        <td>{{ newInvoice.tax }}</td>-->
                      <tr class="summary-row summary-row--total">
                        <td class="summary-label-cell">
                          <span class="summary-label">Gesamtsumme</span>
                        </td>
                        <td class="summary-value-cell">
                          <div class="summary-value">
                            <span
                              v-html="formatMoney(newInvoice.total, 0, 2)"
                            ></span>
                            <span class="summary-currency">€</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row></v-row>
          </v-container>
        </v-app>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom_button.theme--light.v-btn.v-btn--disabled {
  background-color: lightgray !important;
}
.custom_button {
  background-color: #181c32d1 !important;
}
.invoice-summary-col {
  max-width: 396px;
  margin-left: auto;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.summary-table {
  border: 1px solid #e3ebe4;
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(180deg, #fcfdfb 0%, #f6faf6 100%);
}
.summary-table td {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  vertical-align: middle;
  border-bottom: 1px solid rgba(24, 28, 50, 0.06);
}
.summary-row:last-child td {
  border-bottom: 0;
}
.summary-label-cell {
  width: 58%;
}
.summary-value-cell {
  text-align: right;
  white-space: nowrap;
}
.summary-action-cell {
  text-align: right;
}
.summary-tax-treatment-cell {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.summary-tax-select ::v-deep .v-input__slot {
  min-height: 38px !important;
}
.summary-tax-select ::v-deep .v-label,
.summary-tax-select ::v-deep .v-select__selection {
  font-size: 12px;
}
.summary-row--tax-hint td {
  color: #7a6414;
  background: #fff9dc;
  font-size: 11px;
  line-height: 1.4;
}
.summary-label {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  color: #69707a;
}
.summary-row--discount .summary-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.summary-inline-meta {
  font-size: 11px;
  font-weight: 600;
  color: rgba(58, 142, 47, 0.82);
}
.summary-value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #21272d;
}
.summary-row--action .summary-label {
  color: #39424e;
  font-weight: 600;
}
.summary-row--discount .summary-label,
.summary-row--discount .summary-value {
  color: #3a8e2f;
}
.summary-currency {
  font-size: 0.9em;
  font-weight: 600;
  color: rgba(33, 39, 45, 0.72);
}
.summary-value--discount {
  font-weight: 700;
}
.summary-prefix {
  font-weight: 700;
}
.summary-row--total td {
  padding-top: 12px !important;
  border-top: 1px solid #d8e1d8;
  border-bottom: 0;
}
.summary-row--total .summary-label {
  font-size: 15px;
  font-weight: 700;
  color: #1f252b;
}
.summary-row--total .summary-value {
  font-size: 18px;
  font-weight: 800;
  color: #181c32;
}
.summary-discount-field {
  margin-left: auto;
  margin-right: 0;
  max-width: 92px;
}
.summary-discount-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #53a318;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.summary-discount-trigger:disabled {
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
}
.summary-discount-field ::v-deep .v-input__slot {
  min-height: 34px !important;
}
.summary-discount-field ::v-deep input {
  font-size: 13px;
  text-align: right;
}
.summary-discount-field ::v-deep .v-text-field__suffix {
  font-size: 12px;
}
</style>

<script>
import StatusTypes from "../../../../stub/statustypes";
import InvoiceStub from "../../../../stub/invoice";
import InvoiceItem from "@/view/pages/dashboard/invoice/InvoiceItem";
import Guid from "guid";
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import { LOGOUT } from "@/core/services/store/auth.module";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CustomerSelect from "@/view/pages/dashboard/invoice/CustomerSelect.vue";
import { formatMoney } from "@/helpers/utilities";

export default {
  name: "Create",
  components: {
    InvoiceItem,
    CustomerSelect,
    Loading
  },
  data() {
    return {
      pageTitle: "",
      menu: false,
      menuServiceRange: false,
      newInvoice: {
        invoice_date: null,
        service_range: [],
        invoice_number: "",
        user_id: null,
        //invoice_template_id: 1,
        sub_total: 0,
        discount_percent: 0,
        discount_amount: 0,
        status: "DRAFT",
        edited: 0,
        total: 0,
        tax: 0,
        notes: null,
        files: null,
        unique_hash: null,
        company_id: 1,
        documents_type_id: null,
        currency_id: 1,
        template_id: null,
        client_id: null,
        tax_type_id: null,
        permanent_invoice: 0,
        additional_notes: null,
        is_paid: false,
        items: [
          {
            ...InvoiceStub,
            id: Guid.raw()
          }
        ],
        bankDetails_id: 1,
        fixed_texts_id: 1
      },
      company: { Name: "" },
      bankDetails: [],
      currencies: [],
      templates: [],
      status_types: { ...StatusTypes },
      taxes: [],
      selectedCurrency: "", //Todo: need solution
      customerSelect: null,
      selectedFixedTexts: [],
      discountPercentInput: "0",
      isDiscountInputVisible: false,
      isLoadingInvoice: false,
      isLoadingData: false,
      isLoading: false,
      InvoiceFields: [
        "customer",
        "customerCustom",
        "company",
        "invoice",
        "invoiceCustom"
      ],
      customerId: null,
      unit_item: []
    };
  },
  created: function() {
    this.newInvoice.invoice_date = moment(new Date(), "YYYY-MM-DD").format(
      "YYYY-MM-DD"
    );
    // initialize service range to empty array (user chooses range)
    this.newInvoice.service_range = [];

    let unique_hash = this.$route.params.hash;
    let company = this.$route.params.company;
    let documents_type_id = this.$route.query.type;

    if (unique_hash) {
      this.isLoading = true;
      ApiService.query("invoice/show", unique_hash)
        .then(({ data }) => {
          this.isLoading = false;
          // merge server invoice into reactive object to keep reactivity -> before: this.newInvoice = data.invoice;
          Object.assign(this.newInvoice, data.invoice);
          // support old single-field service_date or new range fields
          const _svcFrom = data.invoice.service_from
            ? moment(data.invoice.service_from).format("YYYY-MM-DD")
            : null;
          const _svcTo = data.invoice.service_to
            ? moment(data.invoice.service_to).format("YYYY-MM-DD")
            : null;
          this.newInvoice.service_range =
            _svcFrom && _svcTo ? [_svcFrom, _svcTo] : [];
          this.syncDiscountPercentInput();
          this.customerSelect = data.invoice.client;
          this.customerId =
            data.invoice.client_id ||
            (data.invoice.client ? data.invoice.client.id : null);
          this.company = data.invoice.company;
          this.getDocumentSettings();
        })
        .catch(({ response }) => {
          this.isLoading = false;
          if (response.status === 401) {
            this.$store
              .dispatch(LOGOUT)
              .then(() => this.$router.push({ name: "login" }));
          }
        });
    } else if (!company) {
      // To overview if company not selected
      this.$router.push({
        name: "dashboard",
        pathToRegexpOptions: { strict: true }
      });
    } else {
      this.company = this.$route.params.company;
      this.newInvoice.company_id = this.$route.params.company.CompanyId;
      this.getDocumentSettings();
    }

    if (documents_type_id) {
      this.newInvoice.documents_type_id = documents_type_id;
      this.setPageTitle();
    }

    this.syncDiscountPercentInput();
  },
  methods: {
    setPageTitle() {
      let title = "";
      switch (String(this.newInvoice.documents_type_id)) {
        case "1":
          title = "RECHNUNG";
          break;
        case "2":
          title = "GUTSCHRIFT";
          break;
        case "3":
          title = "STORNIERUNG";
          break;
        default:
          title = "";
      }
      this.pageTitle = title;
    },
    getDocumentSettings() {
      let currentYear = new Date().getFullYear();
      ApiService.query(
        "settings",
        currentYear + "/" + this.newInvoice.company_id
      )
        .then(({ data }) => {
          this.isLoading = false;

          this.taxes = data.tax_types;
          this.currencies = data.currencies;
          this.templates = data.templates;

          this.unit_item = data.unit_item;

          if (!this.$route.params.hash) {
            this.newInvoice.invoice_number = data.next_invoice_number;
            this.newInvoice.currency_id = data.currencies[0].id;
            this.newInvoice.template_id = data.templates[0].id;
            if (!this.newInvoice.tax_type_id) {
              this.newInvoice.tax_type_id = this.standardTaxTypeId;
            }
          }

          this.bankDetails = data.bankDetails;
          this.selectedFixedTexts = data.fixed_texts;
          this.recalcTotals();
          this.loadingvariable = false;
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.loadingvariable = false;
            this.$store
              .dispatch(LOGOUT)
              .then(() => this.$router.push({ name: "login" }));
          }
        });
    },
    onFilePicked() {
      //const files = e.target.files;
      //console.log(this.newInvoice.files);
      /*if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }*/
    },
    editDocument() {
      Swal.fire({
        title: "Dieses Dokument wurde bereits finalisiert",
        text:
          "Achtung:\n" +
          "Änderungen an Rechnungsnummern und -daten können die chronologische Reihenfolge der Dokumente beeinträchtigen. Dieses Dokument wurde bereits abgeschlossen.",
        icon: "warning",
        timerProgressBar: true,
        showCancelButton: true,
        cancelButtonText: "Abbrechen",
        confirmButtonText: "Ok"
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          ApiService.post("/invoice/edit/" + this.newInvoice.unique_hash)
            .then(({ data }) => {
              this.isLoading = false;

              Swal.fire({
                text: data.message,
                icon: "success",
                buttons: false,
                timer: 2000
              }).then(() => {
                window.location.reload();
              });
            })
            .catch(({ response }) => {
              if (response.status === 403) {
                Swal.fire("", response.data.message, "error");
              }
              if (response.status === 401) {
                if (response.status === 401) {
                  this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({ name: "login" }));
                }
              }
              this.isLoading = false;
            });
        }
      });
    },
    saveInvoice(status) {
      if (this.isValid()) {
        this.isLoading = true;
        this.newInvoice.status = status;

        let formData = new FormData();

        // files
        if (this.newInvoice.files) {
          for (let file of this.newInvoice.files) {
            if (file.size) formData.append("file[]", file, file.name);
          }
        }
        formData.append("json", JSON.stringify(this.newInvoice));
        //formData.forEach(el => console.log(el))

        //ApiService.post("/invoice/store", { newInvoice: this.newInvoice, files: logoData })
        //console.log(this.newInvoice);

        ApiService.post("/invoice/store", formData)
          .then(async ({ data }) => {
            this.isLoading = false;
            this.newInvoice.status = data.invoice.status;
            this.newInvoice.unique_hash = data.invoice.unique_hash;
            this.newInvoice.user_id = data.invoice.user_id;
            this.newInvoice.sub_total = data.invoice.sub_total;
            this.newInvoice.discount_percent =
              data.invoice.discount_percent || 0;
            this.newInvoice.discount_amount = data.invoice.discount_amount || 0;
            this.newInvoice.tax = data.invoice.tax;
            this.newInvoice.total = data.invoice.total;
            this.syncDiscountPercentInput();
            // check if InvoiceNumber updated
            if (
              this.newInvoice.invoice_number !== data.invoice.invoice_number
            ) {
              await Swal.fire({
                title: "Aktualisierung erfolgt",
                text:
                  "Die Gutschrift- oder Rechnungsnummer wurde auf die folgende Nummer aktualisiert: " +
                  data.invoice.invoice_number,
                icon: "info",
                heightAuto: false
              });
              this.newInvoice.invoice_number = data.invoice.invoice_number;
            }

            if (data.validation_warning) {
              await this.showValidationWarning(data.validation_warning);
            }
          })
          .catch(({ response }) => {
            this.isLoading = false;
            if (response.status === 422) {
              const reportHtml =
                response.data.report_html || response.data.details;

              Swal.fire({
                title: "Fehler beim Speichern",
                text: response.data.message,
                icon: "error",
                heightAuto: false,
                showCancelButton: Boolean(reportHtml),
                confirmButtonText: "Schließen",
                cancelButtonText: "Bericht öffnen"
              }).then(result => {
                if (result.dismiss === Swal.DismissReason.cancel) {
                  this.openValidationReport(reportHtml);
                }
              });
            }
            // --- BEGIN PATCH: 503 handler ---
            else if (response.status === 503) {
              this.newInvoice.status = this.status_types.STATUS_DRAFT;
              Swal.fire({
                title: "Fehler bei der E-Rechnung",
                text:
                  response.data.message ||
                  "Netzwerkfehler oder Server nicht erreichbar.",
                icon: "error",
                heightAuto: false
              });
              return;
            }
            // --- END PATCH: 503 handler ---
            else if (response.status === 401) {
              this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({ name: "login" }));
            }
          });
      }
    },
    getPdf() {
      this.isLoading = true;
      ApiService.getFile("/invoice/pdf", this.newInvoice.unique_hash)
        .then(response => {
          this.isLoading = false;
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            this.newInvoice.invoice_number + ".pdf"
          );
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(({ response }) => {
          this.isLoading = false;
          if (response.status === 401) {
            if (response.status === 401) {
              this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({ name: "login" }));
            }
          }
        });
    },
    getPDFDraft() {
      this.isLoading = true;
      ApiService.getFile("/invoice/draftPdf", this.newInvoice.unique_hash)
        .then(response => {
          this.isLoading = false;
          const contentType = response.headers["content-type"];

          if (contentType.includes("application/pdf")) {
            // Alles gut, PDF anzeigen
            const blob = new Blob([response.data], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute(
              "download",
              this.newInvoice.invoice_number + ".pdf"
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(blobUrl);
          } else if (contentType.includes("application/json")) {
            // JSON-Fehler im ArrayBuffer dekodieren
            const decoder = new TextDecoder("utf-8");
            const text = decoder.decode(new Uint8Array(response.data));

            try {
              const json = JSON.parse(text);

              Swal.fire({
                title: "Fehler",
                text:
                  json.message ||
                  "Es liegt ein Validierungsfehler vor. Bitte prüfen Sie den Bericht.",
                icon: "error",
                heightAuto: false
              }).then(() => {
                if (json["report_html"] || json["report"]) {
                  this.openValidationReport(
                    json["report_html"] || json["report"]
                  );
                }
              });
            } catch (e) {
              Swal.fire({
                title: "Fehler",
                text: "Fehlerhafte JSON-Antwort erhalten.",
                icon: "error",
                heightAuto: false
              });
            }
          } else {
            // Unbekannter Inhalt
            Swal.fire({
              title: "Fehler",
              text: "Unbekannter Dateityp zurückgegeben.",
              icon: "error",
              heightAuto: false
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          Swal.fire({
            title: "Fehler",
            text: "Netzwerkfehler oder Server nicht erreichbar.",
            icon: "error",
            heightAuto: false
          });
        });
    },
    async updatePaidStatus() {
      try {
        this.isLoading = true;

        await ApiService.post(
          "invoice/paid/" + `${this.newInvoice.id}/status`,
          { is_paid: this.newInvoice.is_paid ? 1 : 0 }
        );

        Swal.fire({
          icon: "success",
          title: "Gespeichert!",
          text: "Zahlungsstatus wurde erfolgreich aktualisiert.",
          timer: 2000,
          showConfirmButton: false
        });
      } catch {
        Swal.fire({
          icon: "error",
          title: "Fehler",
          text: "Zahlungsstatus konnte nicht gespeichert werden."
        });
      } finally {
        this.isLoading = false;
      }
    },
    sendEmail() {
      this.isLoading = true;
      ApiService.post("/invoice/pdf/send/" + this.newInvoice.unique_hash)
        .then(({ data }) => {
          this.isLoading = false;

          Swal.fire({
            title: "E-Mail erfolgreich versendet",
            text: data.message,
            icon: "success",
            heightAuto: false
          });
          //this.newInvoice.status = data.invoice.status;
          //this.newInvoice.unique_hash = data.invoice.unique_hash;
        })
        .catch(({ response }) => {
          this.isLoading = false;
          if (response.status === 401) {
            this.$store
              .dispatch(LOGOUT)
              .then(() => this.$router.push({ name: "login" }));
          } else if (response.status === 404) {
            Swal.fire({
              title: "Warnung " + response.status,
              text: response.data.message,
              icon: "warning",
              heightAuto: false
            });
          }
        });
    },
    isValid() {
      if (!this.newInvoice.client_id) {
        Swal.fire({
          title: "Warnung",
          text: "Bitte wählen Sie ein Unternehmen aus",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      if (
        !Array.isArray(this.newInvoice.service_range) ||
        this.newInvoice.service_range.length !== 2 ||
        !this.newInvoice.service_range[0] ||
        !this.newInvoice.service_range[1]
      ) {
        Swal.fire({
          title: "Warnung",
          text: "Bitte wählen Sie einen gültigen Leistungszeitraum (von/bis)",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      if (this.newInvoice.service_range[0] > this.newInvoice.service_range[1]) {
        Swal.fire({
          title: "Warnung",
          text: "Das Enddatum darf nicht vor dem Startdatum liegen",
          icon: "warning",
          heightAuto: false
        });
        return false;
      }

      return true;
    },
    addItem() {
      this.newInvoice.items.push({
        ...InvoiceStub,
        id: Guid.raw()
      });
      this.recalcTotals();
    },
    recalcTotals() {
      // Rohwerte aufsummieren (in Cent)
      const rawSum = this.newInvoice.items.reduce(
        (sum, item) => sum + Number(item.total),
        0
      );
      // Zwischensumme in Cent speichern
      this.newInvoice.sub_total = rawSum;

      const discountPercent = this.normalizeDiscountPercent(
        this.newInvoice.discount_percent
      );
      const discountAmount = Math.min(
        rawSum,
        Math.round((rawSum * discountPercent) / 100 + Number.EPSILON)
      );
      const discountedSubTotal = Math.max(rawSum - discountAmount, 0);

      this.newInvoice.discount_percent = discountPercent;
      this.newInvoice.discount_amount = discountAmount;

      const taxCents = Math.round(
        discountedSubTotal * (this.taxPercent / 100) + Number.EPSILON
      );
      this.newInvoice.tax = taxCents;

      // Gesamtsumme in Cent
      this.newInvoice.total = discountedSubTotal + taxCents;
    },
    removeItem(index) {
      this.newInvoice.items.splice(index, 1);
      this.recalcTotals();
    },
    updateItem(data) {
      Object.assign(this.newInvoice.items[data.index], { ...data.item });

      this.recalcTotals();
    },
    checkItemsData(index, isValid) {
      this.newInvoice.items[index].valid = isValid;
    },
    normalizeDiscountPercent(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return 0;
      }

      const normalized = String(value)
        .replace(/\s+/g, "")
        .replace(",", ".")
        .replace(/[^0-9.]/g, "");
      const firstDot = normalized.indexOf(".");
      const sanitized =
        firstDot === -1
          ? normalized
          : normalized.slice(0, firstDot + 1) +
            normalized.slice(firstDot + 1).replace(/\./g, "");
      const parsed = Number(sanitized);

      if (!Number.isFinite(parsed)) {
        return 0;
      }

      return Math.min(100, Math.max(0, Math.round(parsed * 1000) / 1000));
    },
    formatDiscountPercent(value) {
      const normalized = this.normalizeDiscountPercent(value);
      const fixed = normalized.toFixed(3).replace(/\.?0+$/, "");

      return fixed.replace(".", ",");
    },
    openValidationReport(reportHtml) {
      if (!reportHtml) {
        return;
      }

      const newWindow = window.open("", "_blank");

      if (!newWindow) {
        Swal.fire({
          title: "Hinweis",
          text:
            "Der Bericht konnte nicht geöffnet werden. Bitte erlauben Sie Popups für diese Seite.",
          icon: "warning",
          heightAuto: false
        });
        return;
      }

      newWindow.document.open();
      newWindow.document.write(reportHtml);
      newWindow.document.close();
    },
    async showValidationWarning(validationWarning) {
      const warningCount = Number(validationWarning.warning_count || 0);
      const warningText =
        warningCount === 1
          ? "Die E-Rechnung wurde gespeichert, der Validator hat 1 Warnung gemeldet."
          : `Die E-Rechnung wurde gespeichert, der Validator hat ${warningCount} Warnungen gemeldet.`;
      const reportHtml =
        validationWarning.report_html || validationWarning.report || null;

      const result = await Swal.fire({
        title: "E-Rechnung mit Warnung gespeichert",
        text: warningText,
        icon: "warning",
        heightAuto: false,
        showCancelButton: Boolean(reportHtml),
        confirmButtonText: "OK",
        cancelButtonText: "Bericht öffnen"
      });

      if (result.dismiss === Swal.DismissReason.cancel) {
        this.openValidationReport(reportHtml);
      }
    },
    syncDiscountPercentInput() {
      this.discountPercentInput = this.formatDiscountPercent(
        this.newInvoice.discount_percent
      );
      this.isDiscountInputVisible = this.hasDiscountValue;
    },
    updateDiscountPercent(value) {
      this.discountPercentInput = value;
      this.newInvoice.discount_percent = this.normalizeDiscountPercent(value);
      this.recalcTotals();
    },
    normalizeDiscountPercentInput() {
      this.discountPercentInput = this.formatDiscountPercent(
        this.newInvoice.discount_percent
      );
      this.isDiscountInputVisible = this.hasDiscountValue;
    },
    openDiscountInput() {
      if (this.newInvoice.status !== this.status_types.STATUS_DRAFT) {
        return;
      }

      this.isDiscountInputVisible = true;
      if (!this.hasDiscountValue) {
        this.discountPercentInput = "";
      }

      this.$nextTick(() => {
        const input = this.$refs.discountPercentField?.$el?.querySelector(
          "input"
        );

        if (input) {
          input.focus();
        }
      });
    },
    formatMoney,
    customerSelected(selectedCustomer) {
      if (!selectedCustomer) {
        this.newInvoice.client_id = null;
        this.customerId = null;
        return;
      }

      const nextCustomerId = selectedCustomer.id;
      const customerChanged = this.customerId !== nextCustomerId;

      this.newInvoice.client_id = nextCustomerId;
      this.customerId = nextCustomerId;

      if (!this.$route.params.hash && customerChanged) {
        this.applyCustomerPaymentDefault(selectedCustomer);
        this.applyCustomerTaxDefault(selectedCustomer);
      }
    },
    applyCustomerPaymentDefault(selectedCustomer) {
      const paymentFixedTextId = Number(
        selectedCustomer.payment_fixed_text_id || 0
      );
      this.newInvoice.fixed_texts_id = paymentFixedTextId || 1;
    },
    applyCustomerTaxDefault(selectedCustomer) {
      const defaultTaxTypeId = Number(
        selectedCustomer.default_tax_type_id || 0
      );
      this.newInvoice.tax_type_id = defaultTaxTypeId || this.standardTaxTypeId;
      this.recalcTotals();
    },
    onTaxTypeChanged() {
      this.recalcTotals();
    },
    getInvoicePrefix() {
      switch (String(this.newInvoice.documents_type_id)) {
        case "1":
          return "R";
        case "2":
          return "G";
        case "3":
          return "S";
      }
    },
    getBankInformations() {
      if (this.bankDetails.length)
        return (
          this.bankDetails[0].BankName +
          " - " +
          this.bankDetails[0].Iban +
          " - " +
          this.bankDetails[0].BankCode
        );
    }
  },
  computed: {
    //...mapGetters("company", ["defaultCurrency"]),

    //...mapGetters("notes", ["notes"]),

    //...mapGetters("invoice", ["selectedCustomer", "selectedNote"]),

    ...mapGetters("getPageTitle", ["getPageTitle"]),
    currency() {
      return this.selectedCurrency;
    },
    hasDiscountValue() {
      return (
        this.normalizeDiscountPercent(this.newInvoice.discount_percent) > 0
      );
    },
    discountedSubTotal() {
      return Math.max(
        Number(this.newInvoice.sub_total || 0) -
          Number(this.newInvoice.discount_amount || 0),
        0
      );
    },
    selectedTaxType() {
      return this.taxes.find(
        taxType => Number(taxType.id) === Number(this.newInvoice.tax_type_id)
      );
    },
    standardTaxTypeId() {
      const standard = this.taxes.find(
        taxType => taxType.code === "STANDARD_19"
      );
      return standard ? standard.id : this.taxes[0] ? this.taxes[0].id : null;
    },
    taxPercent() {
      return this.selectedTaxType
        ? Number(this.selectedTaxType.percent || 0)
        : 19;
    },
    taxPercentLabel() {
      return String(this.taxPercent).replace(".", ",");
    },
    isIntraCommunityTax() {
      return (
        this.selectedTaxType &&
        this.selectedTaxType.code === "EU_INTRA_COMMUNITY"
      );
    },
    serviceRangeLabel() {
      if (
        !this.newInvoice.service_range ||
        this.newInvoice.service_range.length !== 2
      )
        return "";
      const from = this.newInvoice.service_range[0] || "";
      const to = this.newInvoice.service_range[1] || "";
      return from && to ? `${from} — ${to}` : "";
    }
  },
  watch: {
    newInvoice() {
      this.setPageTitle();
    }
  }
};
</script>
